import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetOrderListRequestDto } from "../../dtos/get-order-list-requets-dto";
import type { GetOrderListResponseDto } from "../../dtos/get-order-list-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetOrderListQueryParams = {
  queryParams: GetOrderListRequestDto;
  options?: Omit<UseQueryOptions<GetOrderListResponseDto>, "queryKey">;
};

export const useGetOrderListQuery = ({
  queryParams,
  options
}: UseGetOrderListQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getOrderList({ ...queryParams }).queryKey,
    queryFn: async () =>
      await OrderService.getOrderList({ payload: queryParams }),
    ...options
  });
};
